export enum PromotionType {
  PercentageDiscount = 'PercentageDiscount',
  FixedValueDiscount = 'FixedValueDiscount',
  MinorValueItem = 'MinorValueItem',
  FixedPriceByPackage = 'FixedPriceByPackage',
  ItemsFixedValueDiscount = 'ItemsFixedValueDiscount',
  ItemsPercentageDiscount = 'ItemsPercentageDiscount',
}
